//#region src/properties/createProperty/hotelWizardStepKeys.ts
var e = [
	"details",
	"amenities",
	"rooms",
	"photos",
	"rate",
	"cancellation",
	"next"
], t = [
	"entry",
	"propertyType",
	"propertyName",
	"address",
	"location",
	"amenitiesAnimation",
	"hotelFacilities",
	"houseRules",
	"photosAnimation",
	"hotelPhotos",
	"roomTypesAnimation"
], n = [
	"descCategories",
	"descPhrases1",
	"descPhrases2",
	"aiGeneration",
	"completion"
], r = (e, t) => `roomType:${e}:${t}`, i = (t) => {
	let n = /^roomType:(\d+):([a-z]+)$/.exec(t);
	if (!n) return null;
	let r = n[2];
	return e.includes(r) ? {
		index: Number(n[1]),
		part: r
	} : null;
}, a = (i) => {
	let a = Number.isFinite(i) ? Math.max(1, Math.trunc(i)) : 1, o = Array.from({ length: a }, (t, n) => e.map((e) => r(n, e))).flat();
	return [
		...t,
		...o,
		...n
	];
};
//#endregion
export { e as HOTEL_ROOM_TYPE_STEP_PARTS, a as hotelWizardStepKeys, i as parseRoomTypeStepKey, r as roomTypeStepKey };
